import cookie from "cookie";
import { clearLoginDateCookie, removeAccessToken } from "./cookieHelper";
import { withIronSessionApiRoute } from "iron-session/next";
import { sessionOptions } from "./session";

const nextUser = withIronSessionApiRoute(async (req, res) => {
  if (req.headers.cookie === undefined) {
    return res.json({
      isLoggedIn: false,
    });
  }

  try {
    const tokens = cookie.parse(req.headers.cookie);
    const token = tokens.access_token;
    const loginDate = tokens.login_date;

    if (token) {
      const url = process.env.NEXT_PUBLIC_API_URL + "/access/user";
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });
      const data = await response.json();

      if (response.ok) {
        res.json({
          isLoggedIn: true,
          access_token: token,
          login_date: loginDate,
          data,
        });
      } else {
        let cookieValue: any = removeAccessToken();
        res.setHeader("Set-Cookie", [cookieValue, clearLoginDateCookie]);
        res.json({
          isLoggedIn: false,
          reason: "Response not ok",
        });
      }
    } else {
      let cookieValue: any = removeAccessToken();
      res.setHeader("Set-Cookie", [cookieValue, clearLoginDateCookie]);
      res.json({
        isLoggedIn: false,
        reason: "No Token",
      });
    }
  } catch (error) {
    let cookieValue: any = removeAccessToken();
    res.setHeader("Set-Cookie", [cookieValue, clearLoginDateCookie]);
    res.json({
      isLoggedIn: false,
      reason: "Something went wrong",
    });
  }
}, sessionOptions);

export { nextUser };
